import { render, staticRenderFns } from "./leaveTime.vue?vue&type=template&id=2c30c1e2&scoped=true"
import script from "./leaveTime.vue?vue&type=script&lang=js"
export * from "./leaveTime.vue?vue&type=script&lang=js"
import style0 from "./leaveTime.vue?vue&type=style&index=0&id=2c30c1e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c30c1e2",
  null
  
)

export default component.exports